module.exports = __webpack_public_path__ + "media/images/products/retailers-socialmedia-2-tweets-blackwells-8b35fbaafa1f69a9abc49f1d88a2b620.jpg";